module.exports = __webpack_public_path__ + "static/hotwire-22b3b38f38f773b2c91070bc13e1e448.svg";